import { action } from 'typesafe-actions';

import { Guest } from 'services/userGuestService';
import { Group } from 'models/group';

export const SET_GUEST = 'SET_GUEST';

export const RESET = 'RESET_GUEST';

export const SET_GROUPS = 'SET_GROUPS';

export interface SetGuest {
  type: typeof SET_GUEST;
  guest: Guest;
}
export interface Reset {
  type: typeof RESET;
}

export interface SetGroups {
  type: typeof SET_GROUPS;
}

export type TravelArrangerGuestActions = SetGuest | Reset | SetGroups;

export const doSetGuest = (guest: Guest) => action(SET_GUEST, guest);

export const doReset = () => action(RESET);

export const doSetGroups = (groups: Group[]) => action(SET_GROUPS, groups);
